import './SelectFighterCtrl.scss';

import Control from "../1. Core/Control";
import Delegate from "../1. Core/Delegate";
import NP from "../1. Core/NP";
import DropPanel from "../1. Core/Controls/DropPanel/DropPanel";
import TextField from "../1. Core/Controls/TextField/TextField";
import {IAthlete, SportType} from "../10. Battle/types";
import {ServerAPI} from "../1. Core/ServerAPI";
import ListBox, {ListBoxItemArgs} from "../1. Core/Controls/ListBox/ListBox";
import {escapeHTML} from "../1. Core/util-fun";
import EditAthleteDialog from "./EditAthleteDialog";
import IconToggleButton from "../1. Core/Controls/IconToggleButton/IconToggleButton";


export default class SelectFighterCtrl extends Control {
	private EvSelected: Delegate;
	private inputField: TextField;
	private _SportType: SportType;
	private _timeId: any;
	private _fightersList: ListBox;
	private dropPanel: DropPanel;
	private _FloatingLabel: string;
	private _listAthletes: IAthlete[];
	private selectedAthlete: IAthlete;
	private _TournamentId: number;
	private _AllowCreateNew: boolean;
	private _Gender: number;
	private editBtn: IconToggleButton;


	constructor(settings: object)
	{
		super(settings);
		this._render();
	}

	_initFields(settings: object)
	{
		this._Gender = null;
		this._AllowCreateNew = false;
		this._FloatingLabel = ''
		this._TournamentId = null;
		this.EvSelected = new Delegate();
		this._SportType = SportType.MMA;
		super._initFields(settings);
	}


	_render()
	{
		this.np_render();

		this.addClass('select-figher');

		this.inputField = new TextField({
			ParentNode: this._root,
			FloatingLabel: this._FloatingLabel,
			EnabledEdit: true,
			EvChanging: () => this.updateList(true),
			InputAttributes: {
				autocomplete: "off"
			},
			EvChanged: () =>
			{
				if (!this.inputField.getValue().trim())
				{
					this.setValue(null);
					this.selectedAthlete = null;
				}
			}
		});

		this.editBtn = new IconToggleButton({
			ParentNode: this._root,
			FontImage: NP.FontImages.edit,
			Tooltip: NP.RM.getString('Create'),
			EvClick: () =>
			{
				(new EditAthleteDialog({
					Athlete: this.selectedAthlete,
					SportType: this._SportType,
					EvOkButtonClick: () => this.setValue(this._Value)
				})).refresh().show()
			}
		})
		this.editBtn.hide();

		this._fightersList = new ListBox({
			EvItemSelected: (s: object, e: ListBoxItemArgs) =>
			{
				if (e.Item.getValue() == 'AddAthlete')
				{
					this.showCreateAthlete();
				}
				else
				{
					let a = this._listAthletes.find(a => a.Id == e.Item.getValue())
					this._Value = e.Item.getValue();
					this.editBtn.show();
					this.selectedAthlete = a;
					this.inputField.setValue(this.getViewName(a, false));
					this.EvSelected.fire(this)
				}
				this.dropPanel.hide();
			}
		});

		if (this._Value)
		{
			this.setValue(this._Value);
		}
	}

	setValue(id: number)
	{
		this._Value = id;
		if (this._Value)
		{

			let a = this._listAthletes ? this._listAthletes.find(a => a.Id == id) : null;
			if (a)
			{
				this.selectedAthlete = a;
				this.inputField.setValue(this.getViewName(a, false));
			}

			ServerAPI.get<IAthlete>(`/athlete/${this._Value}`).then(athlete =>
			{
				if (athlete)
					this.inputField.setValue(this.getViewName(athlete, false));
				this.selectedAthlete = athlete;
			});
			this.editBtn.show();
		}
		else
		{
			this.inputField.setValue('');
			this.editBtn.hide();
		}
	}

	boldString(str, substr)
	{
		let strRegExp = new RegExp(substr, 'gi');
		return str.replace(strRegExp, '<b>' + substr + '</b>');
	}

	getViewName(a: IAthlete, boldFilterText: boolean)
	{
		let filterText = this.inputField.getValue().trim();
		let fn = boldFilterText ? this.boldString(a.FirstName, filterText) : a.FirstName
		let ln = boldFilterText ? this.boldString(a.LastName, filterText) : a.LastName
		let res = boldFilterText ? `${fn}&nbsp;${ln}` : `${fn} ${ln}`;

		if (a.CountryName)
			res += (boldFilterText ? '&nbsp;' : '') + ` (${escapeHTML(a.CountryName)})`

		if (a.DateBirth)
			res += (boldFilterText ? '&nbsp;' : '') + ` (${a.DateBirth})`

		return res;
	}

	getSelectedAthlete()
	{
		return this.selectedAthlete;
	}

	setTournament(value: number)
	{
		this._TournamentId = value;
	}

	setGender(value: number)
	{
		this._Gender = value
	}

	updateList(dropPanel = false)
	{
		if (this._timeId)
			clearTimeout(this._timeId)

		this._timeId = setTimeout(() => this.doUpdateList(dropPanel), 444)
	}

	async doUpdateList(dropPanel = false)
	{
		let payload = {
			FilterText: this.inputField.getValue(),
			Count: 50,
			SportType: this._SportType,
			TournamentId: this._TournamentId,
			//Sex: this._Gender
		};

		let response = await ServerAPI.post<{ List: IAthlete[], AllCount: number }>("/athlete/items", payload, false)
		this._fightersList.setItems(response.List.map(it => ({
			Content: this.getViewName(it, true),
			Value: it.Id
		})))

		this._listAthletes = response.List;


		if (response.List.length == 50)
			this._fightersList.addItem({
				Content: '...'
			})

		if (this._AllowCreateNew)
			this._fightersList.addItem({
				Content: '... ' + NP.RM.getString('AddAthlete') + ' ...',
				Value: 'AddAthlete'
			})

		if (dropPanel)
			this.showItemsList()
	}

	showItemsList()
	{
		if (!this.isLive())
			return;
		if (!this.dropPanel)
			this.dropPanel = new DropPanel({
				AutoClose: true,
				Class: 'select-figher__dropdown',
				EnableResize: false,
				FocusOnOpen: false,
				Height: 300,
				Width: 450,
				Content: this._fightersList
			});
		NP.showDropPanel(this.dropPanel, this._root, NP.LTRB.Bottom, undefined, false);
	}

	showCreateAthlete()
	{
		(new EditAthleteDialog({
			SportType: this._SportType,
			EvOkButtonClick: (s: object, e: { Id: number }) =>
			{
				this.setValue(e.Id)
			}
		})).refresh().show()
	}
}